import { writable } from 'svelte/store';
import type { GridLayout } from './camera-monitoring-settings';

export type CameraGridLayoutOption = { value: GridLayout; icon: string; cols: number };

/**
 * Snapshot of everything the Camera Monitoring dashboard needs to expose in the
 * dashboard Tabs action-slot kebab. `CameraMonitoringRoute` owns the derivation
 * (layout availability, current settings, camera list) and publishes it here so
 * the kebab — rendered by `MainLayoutNew` in the shared Tabs rail — can drive the
 * dashboard without owning its own toolbar. `null` while the dashboard is unmounted.
 */
export type CameraMonitoringActionsState = {
	availableGridLayouts: CameraGridLayoutOption[];
	selectedLayout: GridLayout;
	hideOfflineCameras: boolean;
	hasCameras: boolean;
	onLayoutChange: (layout: GridLayout) => void;
	onOpenSettings: () => void;
	onToggleHideOffline: () => void;
};

/**
 * Camera reorder ("edit") mode. Shared so the kebab can enter it and the route
 * can render the draggable grid + exit affordance off the same state.
 */
export const cameraMonitoringEditMode = writable<boolean>(false);

export const cameraMonitoringActions = writable<CameraMonitoringActionsState | null>(null);
